let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // The rest of your code to handle experiments goes here.
  // This code will only run once both conditions are met.
  //Testimonial in Drawer

  const c_Testimonial_test = window.igData?.user.getTestGroup(
    "922dc703-f6d8-4c39-8b7b-0a72f40363b5"
  );

  if (c_Testimonial_test?.name === "Var A") {
    document.querySelectorAll(".C-testimonial").forEach((el) => {
      el.style.display = "flex";
    });
  }

  //Sold-Out pdp test
  const c_soldOutTest = window.igData?.user.getTestGroup(
    "2c4594fd-e6e9-4e92-9dd2-e83857928eb0"
  );

  // Function to mark the "Sold in Last 3 Months" badge for CSS targeting
  function markSoldBadge() {
    const soldBadge = Array.from(document.querySelectorAll('.text-with-icon')).find(el => 
      el.textContent.includes('Sold in the Last 3 Months')
    );
    if (soldBadge && !soldBadge.classList.contains('c-soldBadge')) {
      soldBadge.classList.add('c-soldBadge');
    }
  }


  markSoldBadge();


  const observer = new MutationObserver(() => {
    markSoldBadge();
  });

 
  const productForm = document.querySelector('product-information') || document.querySelector('.product-single');
  if (productForm) {
    observer.observe(productForm, { childList: true, subtree: true });
  }


  if (c_soldOutTest?.name === "Var A") {
    document.body.classList.add("c-soldout-varA");
  } else {
    document.body.classList.add("c-soldout-control");
  }
}

// Check if DOM is already loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    domLoaded = true;
    handleExperiments();
  });
} else {
  domLoaded = true;
  handleExperiments();
}

// Check for ig:ready event
if (window.igData) {
  igReady = true;
  handleExperiments();
} else {
  window.addEventListener("ig:ready", () => {
    igReady = true;
    handleExperiments();
  });
}
